import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';

export default function CoordsModal({ open, onClose, onSave }) {
  const [input, setInput] = useState('');

  const handleSave = () => {
    const match = input.match(/^\s*(-?\d+(\.\d+)?)\s*,\s*(-?\d+(\.\d+)?)\s*$/);
    if (!match) {
      alert("Formato inválido. Usa: -12.00156295, -77.05527454");
      return;
    }
    onSave(match[1], match[3]);
    setInput('');
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Ingresar Coordenadas</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Coordenadas"
          fullWidth
          placeholder="-12.00156295, -77.05527454"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <small>
          Copia este formato desde Google Maps. Click derecho sobre la ubicación y copia las coordenadas.
        </small>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
}
